import DashboardManagementPage from '../pages/DashboardManagementPage'

const routes = [
    { name: 'DashboardManagementPage', path: '/dashboard-management', component: DashboardManagementPage },
]

export default routes;
